import { render, staticRenderFns } from "./PartOfSpeech.vue?vue&type=template&id=4e4e13d8&scoped=true&lang=jsx&"
import script from "./PartOfSpeech.vue?vue&type=script&lang=ts&"
export * from "./PartOfSpeech.vue?vue&type=script&lang=ts&"
import style0 from "./PartOfSpeech.vue?vue&type=style&index=0&id=4e4e13d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e4e13d8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\koen\\workspace\\cf2\\src\\frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4e4e13d8')) {
      api.createRecord('4e4e13d8', component.options)
    } else {
      api.reload('4e4e13d8', component.options)
    }
    module.hot.accept("./PartOfSpeech.vue?vue&type=template&id=4e4e13d8&scoped=true&lang=jsx&", function () {
      api.rerender('4e4e13d8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/search/form/PartOfSpeech.vue"
export default component.exports